import { useEventListener } from "@vueuse/core";
import { isNil } from "lodash-es";
import { tagsWithUpdatedTag } from "../stores/tag-store.js";

/*
  store: a TagStore instance
  tags: if given, will be updated when a tag is updated
  editingTag: a ref to the tag being edited.  This will be assigned to a tag object
    when editing, and null when not editing.
*/
export const useTagEditController = ({ store, tags, editingTag }) => {
  /* "tagStore.x" -> "x" -> "x-tag:update" */
  const scope = store.$id.split(".").slice(-1);
  const updateEventName = `${scope}-tag:update`;

  if (!isNil(tags)) {
    useEventListener(document, updateEventName, (ev) => {
      const { oldTag, newTag } = ev.detail;
      tags.value = tagsWithUpdatedTag(tags.value, oldTag, newTag);
    });
  }

  const show = async (tag) => {
    editingTag.value = tag;

    if (!isNil(tag.name)) {
      const count = await store.requestCount({ name: tag.name });
      editingTag.value.count = count;
    }
  };

  const dispatchUpdateEvent = (oldTag, newTag) => {
    document.dispatchEvent(
      new CustomEvent(updateEventName, {
        detail: { oldTag, newTag },
      })
    );
  };

  const save = async (newTag) => {
    /* Allow for saving without an ID (tags not attached to a tagging) */
    if (isNil(editingTag.value.id)) {
      await store.updateTagByName({ name: editingTag.value.name, tag: newTag });
    } else {
      await store.updateTag({ oldTag: editingTag.value, newTag });
    }

    if (!isNil(editingTag.value.count)) {
      newTag.count = await store.requestCount({ name: newTag.name });
    }

    dispatchUpdateEvent(editingTag.value, newTag);

    editingTag.value = null;
  };

  const cancel = () => {
    editingTag.value = null;
  };

  const destroy = () => {
    store.destroyAllTags({ tag: editingTag.value });
    dispatchUpdateEvent(editingTag.value, null);
    editingTag.value = null;
  };

  return { show, save, cancel, destroy };
};
